import { Component } from 'react'

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }
  static getDerivedStateFromError(error) {
    return { error }
  }
  componentDidCatch(error, info) {
    console.error('App crashed:', error, info)
  }
  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: '40px 24px', fontFamily: 'sans-serif', color: colors.text, background: '#0c1520', minHeight: '100vh' }}>
          <div style={{ fontSize: '32px', marginBottom: '16px' }}>⚠️</div>
          <div style={{ fontSize: '18px', fontWeight: 700, marginBottom: '8px' }}>Something went wrong</div>
          <div style={{ fontSize: '13px', color: `rgba(${colors.textRgb},0.6)`, marginBottom: '24px', lineHeight: 1.6 }}>
            {this.state.error?.message}
          </div>
          <button onClick={() => window.location.reload()} style={{ padding: '12px 24px', background: '#c9972b', border: 'none', borderRadius: '10px', color: '#0f1928', fontWeight: 700, fontSize: '14px', cursor: 'pointer' }}>
            Reload app
          </button>
        </div>
      )
    }
    return this.props.children
  }
}
